"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("@dom/config"));

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var api = {
  getWithToken: function getWithToken(url) {
    return constructApi({
      url: url,
      method: 'get',
      token: true
    });
  },
  postWithoutToken: function postWithoutToken(url, data) {
    return constructApi({
      url: url,
      method: 'post',
      data: data
    });
  },
  get: function get(url) {
    return constructApi({
      url: url,
      method: 'get'
    });
  },
  postAsAGuest: function postAsAGuest(url, data, guestToken) {
    return constructApi({
      url: url,
      method: 'post',
      data: data,
      token: true,
      guestToken: guestToken
    });
  },
  post: function post(url, data) {
    return constructApi({
      url: url,
      method: 'post',
      data: data,
      token: true
    });
  },
  put: function put(url, data) {
    return constructApi({
      url: url,
      method: 'put',
      data: data,
      token: true
    });
  },
  putFile: function putFile(url, data) {
    return constructApi({
      url: url,
      method: 'put',
      data: data,
      token: true,
      header: true
    });
  },
  patch: function patch(url, data) {
    return constructApi({
      url: url,
      method: 'patch',
      data: data,
      token: true
    });
  },
  patchWithoutToken: function patchWithoutToken(url, data) {
    return constructApi({
      url: url,
      method: 'patch',
      data: data
    });
  },
  "delete": function _delete(url, data) {
    return constructApi({
      url: url,
      method: 'delete',
      data: data,
      token: true
    });
  },
  postFormDataWithoutToken: function postFormDataWithoutToken(url, data) {
    return constructApi({
      url: url,
      method: 'post',
      data: data,
      header: 'form'
    });
  },
  putWithoutToken: function putWithoutToken(url, data) {
    return constructApi({
      url: url,
      method: 'put',
      data: data
    });
  }
};

var constructApi = function constructApi(_ref) {
  var url = _ref.url,
      method = _ref.method,
      data = _ref.data,
      token = _ref.token,
      header = _ref.header,
      guestToken = _ref.guestToken;
  return (0, _axios["default"])(constructOptions(url, method, data, token, header, guestToken));
};

var constructOptions = function constructOptions(url, method, data, token, header, guestToken) {
  return data ? _objectSpread({}, commonOptionsParams(url, method, token, header, guestToken), {
    data: data
  }) : _objectSpread({}, commonOptionsParams(url, method, token, header, guestToken));
};

var commonOptionsParams = function commonOptionsParams(resource, method, token, header, guestToken) {
  return {
    url: "".concat(_config["default"].ENDPOINT, "/").concat(resource),
    method: method,
    headers: constructHeaders(token, header, guestToken)
  };
};

var constructHeaders = function constructHeaders(apiUseToken, apiUseUploadHeader, guestToken) {
  var commonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  var uploadHeaders = {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data'
  };
  var formDataHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  if (apiUseUploadHeader === 'form') {
    return _objectSpread({}, formDataHeaders);
  }

  if (guestToken) {
    return _objectSpread({}, commonHeaders, {
      Authorization: "JWT ".concat(guestToken)
    });
  }

  if (apiUseUploadHeader && apiUseToken) return _objectSpread({}, uploadHeaders, {
    Authorization: "JWT ".concat((0, _utils.getToken)())
  });

  if (apiUseToken) {
    return _objectSpread({}, commonHeaders, {
      Authorization: "JWT ".concat((0, _utils.getToken)())
    });
  } else {
    return _objectSpread({}, commonHeaders);
  }
};

var _default = api;
exports["default"] = _default;